// extracted by mini-css-extract-plugin
module.exports = {"OrderFooter":"OrderCreatePage_OrderFooter__3gVgr","ButtonRow":"OrderCreatePage_ButtonRow__2ilh-","Modal":"OrderCreatePage_Modal__1oUrz"};